import { API_MAP } from 'helpers';
import { map } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { BadgeProps, ContentNew, BannerPub, IBanner } from 'v2/interfaces/settings';

import type { Observable } from 'rxjs';

/**
 * Service responsible for controlling `Settings` component.
 *
 * @class SettingsService
 */
class SettingsService {
  /**
   * @method getBanner
   * @return {Observable} an `IBanner`
   * returned by the API
   */
  public getBanner = (module: string): Observable<IBanner> => {
    return apiService.get('/orbita_settings/banner', { module }).pipe(map((response) => response.data));
  };

  public getBanners = (): Observable<BannerPub[]> => {
    return apiService.get('/banners/self').pipe(map((response) => response.data));
  };

  public getNews = (): Observable<ContentNew[]> => {
    return apiService.get('/modals/self').pipe(map((response) => response.data));
  };

  public actualUserBadge = (customerId: any): Observable<BadgeProps> => {
    return apiService.get(`${API_MAP.customerBadge}`.replace('{customerId}', customerId)).pipe(map((response) => response.data));
  };
}

const SettingsServiceFactory = new SettingsService();
export const settingsFactory = SettingsServiceFactory;
